import React from "react";
import fileSelector from "selectors/fileSelector";
import fileStatusSelector from "selectors/fileStatusSelector";
import { fetchFile } from "actions/file";
import RequireData from "hooks/RequireData";
import moment from "moment";
import CreateJobFormLoader from "./CreateJobFormLoader";

interface Props {
    fileId: string;
}

const CreateJobBody: React.FC<Props> = ({ fileId }) => {
    const [file, status] = RequireData(
        fileSelector(fileId),
        fileStatusSelector(fileId),
        fetchFile(fileId)
    );

    if (status === "error") {
        return <p>An error occurred.</p>;
    }

    if (status === "loading" || !file) {
        return <p>Loading...</p>;
    }

    const createdAt = moment(new Date(file.created_at)).fromNow();

    return (
        <div>
            <p>
                Creating job with <b>{file.friendly_name || "unnamed.blend"}</b>{" "}
                which was uploaded {createdAt}
            </p>
            <hr />
            <CreateJobFormLoader fileId={fileId} />
        </div>
    );
};

export default CreateJobBody;
